import { render } from "./MaterialDetailsBase.vue?vue&type=template&id=8f1e771c&scoped=true"
import script from "./MaterialDetailsBase.vue?vue&type=script&lang=js"
export * from "./MaterialDetailsBase.vue?vue&type=script&lang=js"

import "./MaterialDetailsBase.vue?vue&type=style&index=0&id=8f1e771c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f1e771c"]])

export default __exports__